/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import autobind from 'react-autobind';
import { Redirect, withRouter } from 'react-router-dom';

import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import * as actions from '../../redux/actions';
import MerchantListItem from '../../components/Merchant/MerchantListItem';
import SuperAdminHeader from '../../components/Header/SuperAdmin';
import Footer from '../../components/Footer';
import FilterSorter from '../../components/FilterSorter';

class SuperDashboardPage extends PureComponent {

  constructor(props) {
    super(props);
    autobind(this);

    this.state = this._props2state(props, {
      newMerchantModalOpen: false,
      newMerchantEmail: '',
      newMerchantPassword: '',
      filterByIndex: 0,
      filteredMerchants: []
    })

    this.filterByItems = [
      {
        name: "All", filterFunc: i => true, onSelect: this.filterby
      },
      {
        name: "Storage surpassed", filterFunc: i => i.metrics.storage_available < i.metrics.storage_used, onSelect: this.filterby
      },
      {
        name: "Traffic surpassed", filterFunc: i => i.metrics.traffic_available < i.metrics.traffic_used, onSelect: this.filterby
      }
    ]
  }

  componentDidMount() {
    const { getMerchants } = this.props;
    getMerchants();
  }

  componentWillReceiveProps(props) {
    this.setState(this._props2state(props, this.state))
  }

  _props2state(props, state) {

    const stateObj = {
      ...state
    }
    const { merchants } = props
    let mappedMerchants = []

    if (merchants && merchants.length) {
      mappedMerchants = merchants.map(merchant => ({
        merchantId: merchant._id,
        data: merchant,
        metrics: merchant.metrics,
        manageSubscriptionModalOpen: false
      }))
    }
    stateObj.merchants = mappedMerchants
    stateObj.filteredMerchants = mappedMerchants
    return stateObj
  }

  onSwitch(subscriptionId) {
    this.setState({
      merchants: this.state.merchants.map((merchant) => {

        const { merchantId } = merchant;
        const subscriptions = merchant.subscriptions.map((subscription) => {
          if (subscriptionId === subscription.id) {
            this.props.updateSubscriptionPayment(merchantId, subscriptionId, !subscription.isPayed);
            return Object.assign({}, subscription, {
              isPayed: !subscription.isPayed
            })
          }
          return subscription
        })

        return Object.assign({}, merchant, {
          subscriptions
        })
      })
    })
  }

  onMerchantDelete(merchantId) {
    this.props.deleteMerchant(merchantId, () => {
      this.getMerchants()
    });
  }

  unblock(merchantId) {
    this.props.unblockMerchant({merchantId : merchantId}, () => {
      this.props.getMerchants()
    })
  }

  addNewMerchant() {
    const { newMerchantEmail, newMerchantPassword } = this.state;
    this.props.addMerchant({
      email: newMerchantEmail, password: newMerchantPassword
    }, () => {
      this.setState({
        newMerchantModalOpen: false,
        newMerchantEmail: '',
        newMerchantPassword: ''
      })
      this.getMerchants()
    })
  }

  toggleManageSubscriptionModalOpen(merchantId) {
    this.setState({
      merchants: this.state.merchants.map((merchant) => {
        if (merchant.merchantId === merchantId) {
          return Object.assign({}, merchant, {
            manageSubscriptionModalOpen: !merchant.manageSubscriptionModalOpen
          })
        }

        return merchant
      })
    })
  }

  toggleNewMerchantModalOpen() {
    this.setState({
      newMerchantModalOpen: !this.state.newMerchantModalOpen
    })
  }

  updateNewMerchantEmail(e) {
    this.setState({
      newMerchantEmail: e.target.value
    })
  }

  updateNewMerchantPassword(e) {
    this.setState({
      newMerchantPassword: e.target.value
    })
  }

  impersonate(merchantId) {
    this.props.impersonate(merchantId)
  }

  toggle(target) {
    const field = `dropdownOpen${target}`
    this.setState({
      [field]: !this.state[field]
    })
  }

  filterby(filterByIndex) {
    const { merchants } = this.state;
    const filteredMerchants = merchants.slice(0)
      .filter(this.filterByItems[filterByIndex].filterFunc)
    this.setState({
      filterByIndex, filteredMerchants
    })
  }

  getView() {
    const { filteredMerchants } = this.state
    return (
      <div>
        <div className="items-list-filters justify-content-between">
          <h4 className="mb-0">Merchants</h4>
          <FilterSorter options={[
            {
              type: "dropdown",
              name: "show",
              title: "Show",
              selectedIndex: this.state.filterByIndex,
              items: this.filterByItems,
              isOpen: this.state.dropdownOpenshow,
              toggle: () => this.toggle('show')
            }
          ]}
          />
          {' '}

        </div>
        <div className="items-list items-list--merchants">
          <div className="items-labels">
            <div className="items-label-1">User details</div>
            <div className="items-label-2">Metrics</div>
            <div className="items-label-3">Contact Details</div>
            <div className="items-label-4">Company details</div>
            <div className="items-label-5">Actions</div>
          </div>
          {filteredMerchants.map(merchant => (
            <MerchantListItem
              key={merchant.merchantId}
              merchant={merchant.data}
              impersonate={this.impersonate}
              unblock={this.unblock}
              onDelete={this.onMerchantDelete}
              manageSubscriptionModalOpen={merchant.manageSubscriptionModalOpen}
              toggleManageSubscriptionModalOpen={this.toggleManageSubscriptionModalOpen}
            />
          ))}
        </div>
      </div>
    )
  }

  render() {

    const { impersonating } = this.props;
    const { newMerchantModalOpen, newMerchantEmail, newMerchantPassword } = this.state;

    if (impersonating) {
      return <Redirect to="/dashboard" />
    }

    return (
      <div className="superadmin">
        <SuperAdminHeader />
        <div className="container mt-5">
          {this.getView()}
        </div>
        <Modal isOpen={newMerchantModalOpen} toggle={this.toggleNewMerchantModalOpen} className="modal-md superadmin">
          <ModalHeader>
            <span onClick={this.toggleNewMerchantModalOpen} className="s7-close modal-close" />
          </ModalHeader>
          <ModalBody className="pt-0">
            {/* {error ? <Alert message={error} /> : null} */}
            <label>Email:</label>
            <input type="email" placeholder="Email" className="form-control form-control-xs mb-4" value={newMerchantEmail} onChange={this.updateNewMerchantEmail} />
            <label>Password:</label>
            <input type="text" placeholder="Password" className="form-control form-control-xs mb-4" value={newMerchantPassword} onChange={this.updateNewMerchantPassword} />
            <button className="btn btn-space btn-primary" onClick={this.addNewMerchant}>Add New User</button>
          </ModalBody>
        </Modal>
        <Footer />

      </div>
    );
  }

}

SuperDashboardPage.propTypes = {
  impersonating: PropTypes.object.isRequired,
  impersonate: PropTypes.func.isRequired,
}

export default connect(
  (state, ownProps) => {
    const { merchants: { merchants, error }, products: { merchantProducts }, auth: { impersonating } } = state;
    const tab = ownProps.tab || 'merchants'
    return {
      merchants, tab, merchantProducts, error, impersonating
    }
  },
  actions,
  (stateProps, dispatchProps) => Object.assign({}, stateProps, dispatchProps)
)(withRouter(SuperDashboardPage))



// WEBPACK FOOTER //
// ./src/containers/SuperAdmin/SuperDashboard.js